export enum ContractType {
    NONE = "",
    ALL = "all",
    SELECTED = "selected",
}

export type CustomerCardAuthorizationFormType = MyBrokerApi.Authorization & {
    giveAuthorizationPermission: boolean;
    selectedContracts: number[];
    selectedMandate: number;
    contractType: ContractType;
};

export const customerCardAuthorizationDefaultValues = (): CustomerCardAuthorizationFormType => {
    return {
        giveAuthorizationPermission: false,
        selectedMandate: 0,
        mandates: [],
        selectedContracts: [],
        contracts: "",
        forAllContracts: false,
        forSpecificContracts: false,
        contractType: ContractType.NONE,
    };
};
